import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authorization-gate/package-store/$packageFamilyId/')({
	beforeLoad: ({ params }) => {
		throw redirect({ to: '/package-store/$packageFamilyId/general', params });
	},
});
